

import CitizensList from "./citizens-list";


export default CitizensList;
